module.exports = __webpack_public_path__ + "static/img/b02.dce714e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b02.jpg
// module id = ckUX
// module chunks = 1